// TODO uncomment when available to use
import {
  white,
  dark,
  paleGrey,
  lightBlueGrey,
  lightBlue,
  darkGrey,
  blueGrey,
  brownishGrey,
  greyBlue,
  // skyBlue,
  waterBlue,
  peacockBlue,
  // darkBlue,
  // paleYellow,
  sunflowerYellow,
  // gradientOrange,
  tangerine,
  // lightGradient,
  // blueGradient,
  // darkBlueGradient,
  sunflowerYellowGradient,
  transparentYellowGradient,
} from '@g4/boneyard/lib/theme/colors';

// TODO to remove colors bellow when in theme

const tempColors = {
  seaFoamGreen: '#6bc7b8',
  lightGrey: '#d6d6d6',
  darkGrey: '#454545',
  greyBlue: '#7fabcd',
  lightBlue: '#5891c6',
  fireBrick: '#b71c1c',
  diagonalYellowGradient:
    'linear-gradient(315deg, rgb(255,177,0), rgb(255,210,0))',
  paleGradient:
    'linear-gradient(to bottom, rgb(255,255,255), rgb(230,233,237))',
  cornflowerBlue: '#2275c4',
  highlightBlue: '#1e73c1',
  shadow: '#2632384c',
  lightBlue900: '#01579b',
  grey100: '#cfd8dc',
  grey900: '#263238',
  radialBlackGradient:
    'linear-gradient(90deg, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.65))',
  grey500: '#9e9e9e',
  slateGrey: '#686868',
  green: '#598230',
  red: '#D33100',
  orangeMenuBorder: '#f89728',
  waterBlueGradient: 'rgba(25,118,210,0.85)',
  foamGreen: '#6ccaba',
};

const allegiantBlue = '#01579b';

const colors = {
  common: {
    light: white,
    dark: dark,
    fireBrick: tempColors.fireBrick,
    pageTitle: allegiantBlue,
    link: '#1871ca',
    linkActive: '#13589c',
    error: '#dd2c00',
    peacockBlue: peacockBlue,
    waterBlue: tempColors.waterBlue,
    lightGrey: tempColors.lightGrey,
    grey500: tempColors.grey500,
    brownishGrey: brownishGrey,
    grey900: tempColors.grey900,
  },
  myallegiant: {},
  hob: {},
};

colors.hob.blueSearchWidget = {
  backgroundFrom: peacockBlue,
  backgroundTo: waterBlue,
  backgroundToGradient: tempColors.waterBlueGradient,
  mobileBackgroundFrom: peacockBlue,
  mobileBackgroundTo: waterBlue,
  borderColor: lightBlue,
  label: white,
  roomNum: white,
  summaryLabel: white,
  summaryValue: white,
};

colors.hob.greySearchWidget = {
  backgroundFrom: paleGrey,
  backgroundTo: white,
  mobileBackgroundFrom: paleGrey,
  mobileBackgroundTo: paleGrey,
  borderColor: darkGrey,
  label: peacockBlue,
  roomNum: dark,
  summaryLabel: peacockBlue,
  summaryValue: dark,
  fieldBorderValue: tempColors.grey500,
  boxShadow: tempColors.shadow,
  divider: lightBlueGrey,
};

colors.hob.destinationPicker = {
  options: peacockBlue,
  divider: tempColors.lightGrey,
};

colors.hob.mobileSortFilter = {
  backgroundFrom: blueGrey,
  backgroundTo: white,
};

colors.hob.searchBy = {
  inputBg: '#f3f3f3',
};

colors.hob.activeFilters = {
  background: paleGrey,
  text: peacockBlue,
};

colors.hob.sort = {
  button: brownishGrey,
  activeButton: peacockBlue,
};

colors.hob.filter = {
  name: dark,
  count: brownishGrey,
};

colors.hob.infoTile = {
  information: brownishGrey,
  subInformation: dark,
};

colors.hob.confirmation = {
  contentBackground: white,
  title: peacockBlue,
  confirmationNumber: peacockBlue,
  divider: lightBlueGrey,
  viewMapLink: peacockBlue,
};

colors.hob.shareItinerary = {
  title: peacockBlue,
  additionalInfo: brownishGrey,
  valid: tempColors.green,
  invalid: tempColors.fireBrick,
};

colors.hob.paymentSummary = {
  title: peacockBlue,
};

colors.hob.confirmationIntro = {
  backgroundFrom: peacockBlue,
  backgroundTo: waterBlue,
  title: white,
};

colors.hob.findReservationForm = {
  title: peacockBlue,
  error: tempColors.fireBrick,
};

colors.hob.text = tempColors.brownishGrey;

colors.hob.datePicker = {
  border: peacockBlue,
  active: tempColors.diagonalYellowGradient,
  activeBorder: sunflowerYellow,
  selectedDates: tempColors.cornflowerBlue,
  // selected date range colour
  highlight: tempColors.highlightBlue,
  blueText: peacockBlue,
  background: tempColors.paleGradient,
};

colors.button = {
  lightText: white,
  darkText: peacockBlue,
  disabled: brownishGrey,
  tertiaryDisabled: greyBlue,
  primary: sunflowerYellowGradient,
  secondary: white,
  secondaryDark: peacockBlue,
  hoverPrimary: transparentYellowGradient,
  hoverSecondary: sunflowerYellowGradient,
  hoverGreen: tempColors.seaFoamGreen,
};

colors.toggleButton = {
  bgSelected: white,
  bgDisabled: peacockBlue,
  lightText: white,
  darkText: peacockBlue,
};

colors.hob.input = {
  text: dark,
  placeholder: tempColors.slateGrey,
  disabledText: brownishGrey,
  disabled: paleGrey,
  disabledBorder: '#ced7db',
  focused: '#bbdefb',
};

colors.hob.footer = {
  bg: paleGrey,
  title: peacockBlue,
  link: dark,
  divider: '#cfd8dc',
};
colors.hob.copyright = {
  text: peacockBlue,
  background: white,
};

colors.hob.appMenu = {
  link: peacockBlue,
};

colors.hob.topMenu = {
  link: peacockBlue,

  linkMobile: white,
  linkBg: white,
  linkActive: tangerine,
  subMenuActive: tangerine,
  subMenuSubMenuLink: white,
  subMenuSubMenuActive: tangerine,
  drawer: {
    bg: 'linear-gradient(to top, rgb(1,87,155), rgb(25,118,210))',
    link: white,
    border: tempColors.orangeMenuBorder,
  },
};

colors.hob.strip = {
  bg: white,
};

colors.hob.pod = {
  border: tempColors.lightGrey,
  sunseekerBorder: tempColors.foamGreen,
  borderSelected: waterBlue,
  pricing: {
    promosStripBg: waterBlue,
    promosStripText: white,
    promosModalHeader: peacockBlue,
    promosModalText: dark,
    strikethroughPrice: brownishGrey,
    averagePrice: peacockBlue,
    pricingInfo: brownishGrey,
  },
};

colors.hob.roomItem = {
  border: tempColors.lightGrey,
  selectedPillBg: sunflowerYellow,
  selectedPillText: peacockBlue,
  borderSelected: waterBlue,
  selectedText: white,
  heading: peacockBlue,
  errorMessage: tempColors.red,
  pricing: {
    bg: paleGrey,
    promosStripBg: waterBlue,
    promosStripText: white,
    priceFull: brownishGrey,
    priceDiscounted: peacockBlue,
  },
};

colors.hob.hotelItem = {
  border: tempColors.lightGrey,
  borderSelected: waterBlue,
  textSelected: white,
  primaryText: peacockBlue,
  primaryBackground: sunflowerYellow,
  promoBackground: waterBlue,
  strikethroughPrice: tempColors.darkGrey,
  priceText: brownishGrey,
  lightText: tempColors.lightGrey,
  heading: peacockBlue,
  priceBackground: paleGrey,
  highlightText: waterBlue,
};

colors.hob.expando = {
  border: tempColors.lightGrey,
};

colors.hob.hotel = {
  carouselGradient: tempColors.radialBlackGradient,
  slideDescriptionBackground: waterBlue,
  totalProperties: tempColors.slateGrey,
};

colors.hob.paymentPage = {
  label: tempColors.darkGrey,
};

colors.hob.breadcrumb = {
  active: peacockBlue,
  inactive: brownishGrey,
  divider: '#9e9e9e',
  border: lightBlueGrey,
};

colors.hob.tabs = {
  activeTabBorderColor: tempColors.lightBlue900,
  tabsWrapperBorderColor: tempColors.grey100,
  tabsContentText: tempColors.grey900,
};

colors.hob.login = {
  background: paleGrey,
  separator: '#cfd8dc',
  color: '#263238',
};
colors.hob.errorPage = {
  color: tempColors.lightBlue900,
};

// TODO remove bottom props when unused

colors.plainButton = {
  secondary: dark,
  tertiary: peacockBlue,
};

colors.myallegiant.topMenu = {
  link: '#fff',
  linkBg: allegiantBlue,
  linkActive: '#bbdefb',
  subMenuActive: '#1565c0',
  subMenuSubMenuLink: '#1565c0',
  subMenuSubMenuActive: '#1871ca',
};

colors.myallegiant.table = {
  errorBorder: '#dc3000',
  errorBackground: '#faeee5',
  divide: '#e0e0e0',
};

colors.myallegiant.fieldMask = {
  disabledBackground: '#f4f5f6',
  disabledText: '#90a4ae',
  disabledBorderColor: '#cfd8dc',
  borderColor: '#cfd8dc',
  disabledBoxShadow: '#eceff1',
};

colors.myallegiant.field = {
  error: '#dd2c00',
};

// Deep extends the boneyard theme
const theme = {
  colors,
};

// Responsive mobile-first font size mapping
theme.headings = {};

// XS screens and up
theme.headings.xs = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
  xxl: 24,
};

// LG screens and up
theme.headings.lg = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  xxl: 32,
};

export default theme;